export const formatDate = (dateString) => {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

export const getRangeSalary = (startSalary, endSalary, levelSalary) => {
  if (startSalary || endSalary || levelSalary) {
    return (
      levelSalary ||
      `${startSalary.slice(0, -6)} - ${endSalary.slice(0, -6)} triệu`
    );
  }
  return "Thỏa thuận";
};

export function fDate(dateString) {
  if (!dateString) return "";
  const parts = dateString.split("/");
  const dateObject = new Date(parts[2], parts[0] - 1, parts[1]);
  return dateObject;
}

const isVietnamesePhoneNumber = (number) => {
  const pattern = /^(03|05|07|08|09|01[2689])\d{8}$/;
  return pattern.test(number);
};

export const validate = (data) => {
  const errors = {};

  if (!data.fullname) {
    errors.fullname = "Vui lòng nhập đầy đủ họ và tên.";
  }

  if (!data.email) {
    errors.email = "Vui lòng nhập email.";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
    errors.email = "Email không đúng định dạng.";
  }

  if (!data.phoneNumber) {
    errors.phoneNumber = "Vui lòng nhập số điện thoại.";
  } else if (!isVietnamesePhoneNumber(data.phoneNumber)) {
    errors.phoneNumber = "Số điện thoại không đúng định dạng.";
  }

  if (!data.dateOfBirth) {
    errors.dateOfBirth = "Vui lòng nhập ngày sinh.";
  } else if (!/^\d{2}\/\d{2}\/\d{4}$/.test(data.dateOfBirth)) {
    errors.dateOfBirth = "Ngày sinh phải có định dạng dd/MM/yyyy.";
  }

  if (!data.address) {
    errors.address = "Vui lòng nhập nơi ở hiện tại.";
  }

  if (!data.fileCV) {
    errors.fileCV = "Vui lòng gửi CV của bạn cho hệ thống.";
  }

  if (data.coverLetter && data.coverLetter.length > 5000) {
    errors.coverLetter = "Thư xin việc không được vượt quá 5000 ký tự.";
  }

  return errors;
};
